import { useState, type PropsWithChildren } from 'react';

import FilterIcon from '~shared/assets/icons/filter.svg?react';

import { Button } from '@breezeventures/ui-kit/button';
import { Modal } from '@breezeventures/ui-kit/modal';
import { Typography } from '@breezeventures/ui-kit/typography';
import cn from 'classnames';

type Props = PropsWithChildren<{
  className?: string;
  activeCount?: number;
  onApply: () => void;
  onClear: () => void;
}>;

export function FloatingFilterButton({
  activeCount = 0,
  className,
  onApply,
  onClear,
  children,
}: Props) {
  const [opened, setOpened] = useState(false);

  const apply = () => {
    onApply();
    setOpened(false);
  };

  return (
    <>
      <Button
        type="button"
        size="m"
        variant="primary"
        className={cn(
          `
            fixed! bottom-floating-filter-bottom left-1/2 z-40 -translate-x-1/2
            shadow-custom-md
          `,
          className
        )}
        onClick={() => setOpened(true)}
      >
        <FilterIcon className="size-4" />
        Filters
        {activeCount > 0 && (
          <span
            className={`
              inline-flex h-5 min-w-5 items-center justify-center rounded-full
              bg-neutral-6-on-light px-1.5 text-sm leading-none font-medium
              text-white
            `}
          >
            {activeCount}
          </span>
        )}
      </Button>

      <Modal opened={opened} onClose={() => setOpened(false)}>
        <Typography.Text
          size="m"
          weight="medium"
          tag="p"
          className="mb-4 text-center"
        >
          Filters
        </Typography.Text>

        <div className="flex flex-col gap-3">{children}</div>

        <div className="mt-6">
          <Modal.FooterActions>
            <Button
              type="button"
              variant="secondary"
              size="l"
              width="full"
              onClick={onClear}
            >
              Clear filters
            </Button>
            <Button
              type="button"
              variant="primary"
              size="l"
              width="full"
              onClick={apply}
            >
              Apply
            </Button>
          </Modal.FooterActions>
        </div>
      </Modal>
    </>
  );
}
